export function go (url, $router) {
  if (/^javas/.test(url) || !url) return
  const useRouter = typeof url === 'object' || ($router && typeof url === 'string' && !/http/.test(url))
  if (useRouter) {
    if (typeof url === 'object' && url.replace === true) {
      $router.replace(url)
    } else {
      url === 'BACK' ? $router.go(-1) : $router.push(url)
    }
  } else {
    window.location.href = url
  }
}

const hostMap = {
  'm.octomaster.com': 'https://octomaster.com',
  'm-spring.kloebuild.com': 'https://spring.kloebuild.com',
  'localhost': 'http://springseeds.test'
}
export function getBackendHost (location) {
  return hostMap[location.hostname]
}



// WEBPACK FOOTER //
// ./src/components/libs/misc.js